<template>
<div class="footer">
</div>
</template>

<script>
export default {
  name: 'global-footer',
  data() {
    return {}
  },
  methods: {
  },
}
</script>
